export const createSpaceHeader = (spaceId: string) => ({
  space: spaceId,
})
